import AxL from '../js/axl.js';
export default class Navigation {
	constructor(scope) {
		this.scope = scope;
		this.build();
	}
	build() {
		console.log('build navigation');
		this.artworkInfo = mdc.dialog.MDCDialog.attachTo(document.querySelector('.mdc-dialog.sharing'));
		this.setCardInteractionNew();
		window.mdc.autoInit();
	}
	setCardInteractionNew() {
		this.scope.scope.presetDifficulty = 'beginer';
		this.clickHandler = this.onclick.bind(this);
		const chips = document.getElementsByClassName('mdc-chip');
		for (const chip of chips) {
			if (chip.getAttribute('data-level') == this.scope.scope.presetDifficulty) {
				if (!chip.classList.contains('active')) {
					chip.classList.add('active');
				}
			}
			chip.addEventListener('click', this.clickHandler, false);
		}
	}
	onclick(e) {
		console.log('on click', e.target.parentNode);
		let level = e.target.getAttribute('data-level');
		let card = e.target;
		if (!level) {
			level = e.target.parentNode.getAttribute('data-level');
			card = e.target.parentNode;
		}
		if (!level) {
			level = e.target.parentNode.parentNode.parentNode.getAttribute('data-level');
			card = e.target.parentNode.parentNode.parentNode;
		}
		console.log('card/level', card, level);
		this.scope.scope.presetDifficulty = level;
		this.resetCardsNew();
		card.classList.add('active');

		// --> ANALYTICS
		/*
		TRACK	{ action: string, label: (string|undefined), value: (string|undefined), nonInteraction: (boolean|undefined)}
		*/
		if (this.scope.scope.axl) {
			this.scope.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
				action: 'select_level',
				label: 'puzzle_piece',
				value: level,
				nonInteraction: false
			});
		}
	}
	resetCardsNew() {
		const chips = document.getElementsByClassName('mdc-chip');
		for (const chip of chips) {
			chip.classList.remove('active');
		}
	}
}
